// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* START: Onboarding */
.BC-page_Installation img {
    image-rendering: pixelated;
}

.BC-page_Installation .ButtonCustom .Polaris-Button {
    padding: 14px 30px;
    height: 48px;
    background: #ff3000;
    box-shadow: 0px 4px 24px rgba(235, 69, 38, 0.4);
    border-radius: 4px;
    border: 0;
    min-width: 110px;
}

.BC-page_Installation .ButtonCustom .Polaris-Button:hover {
    background: #e82c00;
}

.BC-page_Installation .ButtonCustom .Polaris-Button .Polaris-Button__Text {
    color: white;
    font-weight: 700;
    font-size: 14px;
    letter-spacing: 1px;
    text-transform: uppercase;
    font-family: 'Poppins', sans-serif;
}

.BC-page_Installation .ButtonCustom.disabled .Polaris-Button {
    box-shadow: none;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 4px;
    cursor: not-allowed;
}

.BC-page_Installation .ButtonCustom.disabled .Polaris-Button .Polaris-Button__Text {
    color: #8c9196;
}

.BC-page_Installation.Onboarding *,
.BC-page_Installation.KYC *,
.BC-page_Installation.SuccessInstall * {
    font-family: 'Poppins', sans-serif;
}

.BC-page_Installation.Onboarding:has(.NewUser) * {
    font-family: 'SF Pro Text';
}

.BC-page_Installation.Onboarding .NewUser .title {
    font-family: 'SF Pro Display', 'Poppins';
}

.BC-page_Installation.Onboarding .NewUser .description {
    font-family: 'SF Pro Text';
}

.BC-page_Installation.Onboarding .Polaris-Card {
    max-width: 1120px;
    width: calc(100% - 40px * 2);
    margin: 0 auto;
    margin-top: 74px;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper {
    display: flex;
    position: relative;
}

.BC-page_Installation .BC-page_Installation--Onboarding .control-dots {
    display: flex;
    justify-content: center;
    align-items: center;
}

.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper {
    display: flex;
    flex-direction: row-reverse;
    border-radius: 10px;
    max-height: 640px;
}

.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .preview,
.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .preview img {
    border-radius: 0 10px 10px 0;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .btn-pre,
.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .btn-next {
    position: absolute;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: white;
    top: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);
    cursor: pointer;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .btn-pre {
    transform: translateY(-50%);
    left: -22px;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .btn-next {
    transform: translateY(-50%);
    right: -22px;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .preview {
    width: 576px;
    flex-shrink: 0;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .preview img {
    max-width: 100%;
    height: 100%;
    object-fit: cover;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content {
    flex: 1;
    width: auto;
    min-height: 640px;
    padding: 26px 29px;
    position: relative;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content.form-onboarding-plan {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
}

.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content {
    padding: 26px 40px;
}

@media (max-width: 1024px) {
    .BC-page_Installation.Onboarding .Polaris-Card {
        width: 560px;
    }

    .BC-page_Installation .BC-page_Installation--Onboarding .wrapper {
        flex-direction: column;
    }

    .BC-page_Installation .BC-page_Installation--Onboarding .wrapper .btn-pre,
    .BC-page_Installation .BC-page_Installation--Onboarding .wrapper .btn-next {
        top: 75%;
        z-index: 10;
    }

    .BC-page_Installation .BC-page_Installation--Onboarding .wrapper .preview {
        width: 100%;
    }

    .BC-page_Installation .BC-page_Installation--Onboarding .wrapper .preview img {
        border-radius: 10px 10px 0 0;
    }

    .BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content {
        margin-top: -20px;
        background: white;
        border-radius: 0 0 10px 10px;
    }

    .BC-page_Installation.Onboarding.NewUser .Polaris-Card {
        width: 560px;
    }

    .BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper {
        flex-direction: column;
    }

    .BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .btn-pre,
    .BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .btn-next {
        top: 75%;
        z-index: 10;
    }

    .BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .preview {
        width: 100%;
    }

    .BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .preview img {
        border-radius: 10px 10px 0 0;
    }

    .BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content {
        margin-top: -20px;
        background: white;
        border-radius: 0 0 10px 10px;
    }
}

.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content.form-email-opt .title,
.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content.form-onboarding-plan .title {
    text-align: left;
    margin-bottom: 48px;
    font-family: 'SF Pro Display', sans-serif;
    font-size: 42px;
    font-weight: 700;
    line-height: 44px;
    margin-top: 95px;
}

.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content.form-onboarding-plan .title {
    margin-top: 0;
}

.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content.form-email-opt .subtitle,
.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content.form-onboarding-plan .subtitle {
    text-align: left;
    margin-bottom: 24px;
    font-family: 'Poppins', sans-serif;
    font-size: 30px;
    font-weight: 600;
}

.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content.form-email-opt .desc {
    text-align: left;
    margin-bottom: 32px;
    font-family: 'SF Pro Text', sans-serif;
    line-height: 20px;
}

.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content.form-onboarding-plan .desc {
    text-align: left;
    margin-bottom: 24px;
    font-family: 'SF Pro Text', sans-serif;
    line-height: 20px;
}

.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content.form-email-opt .Polaris-Label .Polaris-Label__Text {
    margin-bottom: 5px;
    font-weight: 400 !important;
}

.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content.form-email-opt .Polaris-FormLayout {
    margin-bottom: 25px;
}

.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content.form-email-opt .Polaris-FormLayout input {
    min-height: 2.375rem;
}

.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content.form-email-opt .Polaris-InlineError .Polaris-InlineError__Icon {
    display: block;
}

.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content.form-email-opt .menu {
    position: static;
    display: block;
    margin-top: 25px;
}

.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content.form-onboarding-plan .menu {
    position: static;
    display: block;
    margin: 0;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .skip {
    text-align: right;
    font-weight: 400;
    font-size: 14px;
    color: #6d7175;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .skip span {
    cursor: pointer;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .badge {
    max-width: fit-content;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0px;
    text-align: center;
    border: 1px solid #eaecf0;
    border-radius: 16px;
    color: #344054;
    background: #f9fafb;
    padding: 2px 8px;
    margin-bottom: 10px;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .title {
    font-weight: 600;
    font-size: 28px;
    line-height: 32px;
    color: #202223;
    margin-top: 120px;
    display: flex;
    align-items: baseline;
    gap: 18px;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .description {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #202223;
    margin-top: 24px;
    padding: 0 10px;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .description.step-5 {
    font-size: 30px;
    line-height: 40px;
    margin-top: 0px;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .step {
    margin-top: 150px;
    position: absolute;
    bottom: 200px;
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .Step,
.render-choice-2 .Polaris-ChoiceList__Choices li {
    display: flex;
    align-items: center;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .Step {
    justify-content: center;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .Step .item {
    width: 6px;
    height: 6px;
    background: #c9ccd0;
    margin: 3px;
    border-radius: 50%;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .Step .active {
    width: 10px;
    height: 10px;
    background: #ff3300;
    border-radius: 50%;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .menu {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-top: 50px;
    bottom: 100px;
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .menu .back {
    display: flex;
    position: absolute;
    left: 45px;
    align-items: center;
    cursor: pointer;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .menu .back .Polaris-Icon {
    width: 12px;
    height: unset;
    margin: 10px;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .menu .back .Polaris-Icon svg {
    fill: black;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .onboarding-features .feature-item {
    gap: 8px;
    border-radius: 8px;
    padding: 16px 24px 16px 16px;
    margin-bottom: 12px;
    background: #fafbfb;
    border: 1px solid #fafbfb;
    cursor: pointer;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .onboarding-features .feature-item.selected {
    border: 1px solid #008060;
    background: #f1f8f5;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .onboarding-features .feature-item.selected .Polaris-Checkbox__Backdrop::before {
    background: #008060;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .onboarding-features .feature-item .label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0;
    min-height: auto;
    margin-bottom: 8px;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .onboarding-features .feature-item .desc {
    color: #6d7175;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .onboarding-features img {
    display: none;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
}

.BC-page_Installation.KYC,
.BC-page_Installation.SuccessInstall {
    padding-bottom: 30px;
}

.BC-page_Installation.KYC .Polaris-Card,
.BC-page_Installation.SuccessInstall .Polaris-Card {
    max-width: 1160px;
    width: calc(100% - 20px * 2);
    margin: 20px auto;
}

.BC-page_Installation .BC-page_Installation--KYC .wrapper {
    display: flex;
}

.BC-page_Installation .BC-page_Installation--KYC .wrapper .content {
    flex: 1;
    padding: 40px 56px;
    position: relative;
    min-height: 600px;
    display: flex;
}

.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .StepForm {
    height: auto;
    position: relative;
    width: 100%;
}

.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .StepForm .title {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 30px;
    color: #202223;
}

.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .StepForm .description {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #6d7175;
}

.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .StepForm .step {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #8c9196;
    margin-top: 40px;
}

.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .StepForm .step-title {
    font-style: normal;
    font-weight: 600;
    font-size: 30px;
    line-height: 40px;
    color: #202223;
}

.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .StepForm .step-description {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #6d7175;
    margin-top: 8px;
}

.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .StepForm .step-form {
    margin-top: 40px;
}

.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .menu {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: relative;
    margin-top: 50px;
    bottom: 0;
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
}

.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .menu .back {
    display: flex;
    position: absolute;
    left: 0;
    align-items: center;
    cursor: pointer;
}

.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .menu .back .Polaris-Icon {
    width: 12px;
    height: unset;
    margin: 10px;
}

.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .menu .back .Polaris-Icon svg {
    fill: black;
}

.BC-page_Installation .BC-page_Installation--KYC .wrapper .preview {
    width: 440px;
}

.BC-page_Installation .BC-page_Installation--KYC .wrapper .preview img {
    width: 440px;
    height: 100%;
    font-size: 0;
    line-height: 0;
    display: block;
}

.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin {
    display: grid;
    grid-template-columns: auto auto;
    grid-gap: 16px;
}

.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item {
    min-height: 166px;
    width: 296px;
    position: relative;
    padding: 20px 12px 20px 20px;
    border: 2px solid #fafbfb;
    border-radius: 8px;
    background: #fafbfb;
}

.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item:hover {
    background: #fff8f6;
    cursor: pointer;
}

.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item:hover~.BC-page_Installation .BC-page_Installation--KYC .wrapper .preview {
    border: 4px solid red;
    border-color: var(--hover);
}

.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item .Polaris-Choice {
    position: absolute;
    right: 12px;
    top: 12px;
}

.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item .Polaris-Choice .Polaris-Checkbox__Backdrop {
    border: 1px solid #c9cccf;
    border-radius: 4px;
}

.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item .Polaris-Choice .Polaris-Checkbox__Backdrop::before {
    background-color: #ff3000;
}

.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item .Polaris-Choice .Polaris-Choice__Control {
    margin-right: 0;
}

.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item .icon {
    width: 24px;
    height: 24px;
}

.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item .title {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #202223;
    margin-top: 8px;
}

.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item .description {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #6d7175;
}

.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item--Selected,
.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item--Selected:hover {
    border: 2px solid #ff8366;
}

.BC-page_Installation .BC-page_Installation--KYC .SelectKind {
    margin-bottom: 20px;
}

.BC-page_Installation .BC-page_Installation--KYC .SelectKind .Polaris-TextField__Input {
    min-height: 56px;
    border: px solid #a1a3ad;
    border-radius: 8px;
}

.BC-page_Installation .BC-page_Installation--KYC .SelectKind .Polaris-TextField {
    --p-focused: white;
    /* --p-focused: #FF3000; */
    border-radius: 10px;
}

.BC-page_Installation .BC-page_Installation--KYC .SelectKind .Polaris-TextField--focus .Polaris-TextField__Input {
    border: 2px solid #ff3000;
}

.BC-page_Installation .BC-page_Installation--KYC .SelectKind .Polaris-TextField__Backdrop {
    border-radius: 8px;
}

.BC-page_Installation .BC-page_Installation--KYC .SelectIndustriesWrapper {}

.BC-page_Installation .BC-page_Installation--KYC .IndustryList {
    padding: 2px;
    display: flex;
    flex-wrap: wrap;
    column-gap: 10px;
    row-gap: 10px;
    gap: 10px;
}

.BC-page_Installation .BC-page_Installation--KYC .IndustryItem {
    padding: 6px 8px;
    background: #f1f2f3;
    border-radius: 4px;
}

.BC-page_Installation .BC-page_Installation--KYC .IndustryItem:not(.IndustryItem__Selected) {
    cursor: pointer;
}

.BC-page_Installation .BC-page_Installation--KYC .IndustryItem__Selected {
    background: #ffefeb;
    color: #ff3000;
}

.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper {
    display: flex;
}

.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content {
    flex: 1;
    min-height: 600px;
    position: relative;
}

.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content .inner-content {
    max-width: 540px;
    color: #202223;
    position: absolute;
    top: 50%;
    left: 50%;
    width: calc(100% - 80px);
    transform: translate(-50%, -50%);
}

.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content .inner-content .title {
    font-weight: 600;
    font-size: 30px;
    line-height: 40px;
    margin-bottom: 35px;
}

.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content .inner-content .description,
.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content .inner-content .list {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 20px;
}

.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content .inner-content .description {
    margin-bottom: 16px;
}

.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content .inner-content .list .item {
    display: flex;
    gap: 10px;
    margin-bottom: 10px;
}

.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content .inner-content .list img {
    margin-top: 4px;
}

.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content .inner-content .list .title2 {
    font-weight: 600;
}

.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content .inner-content .action {
    display: flex;
    gap: 10px;
}

.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content .inner-content .action>.Polaris-Button {
    border: 1px solid #292929;
    box-shadow: 0px 4px 24px 0px #eb452633;
}

.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content .inner-content .action>.Polaris-Button .Polaris-Button__Text {
    text-transform: uppercase;
    color: #292929;
    font-weight: 700;
    font-size: 14px;
}

.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .preview {
    width: 540px;
}

.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .preview img {
    width: 540px;
    height: 100%;
    font-size: 0;
    line-height: 0;
    display: block;
}

.BC-page_Installation .BC-page_Installation--KYC .IndustryList {
    margin-top: 20px;
}

.BC-page_Installation .BC-page_Installation--KYC .step4 {
    height: 100%;
    display: flex;
    align-items: center;
}

.BC-page_Installation .BC-page_Installation--KYC .step4-content .ButtonCustom {
    margin-top: 30px;
}

.BC-page_Installation .BC-page_Installation--KYC .step4-content .ButtonCustom .Polaris-Button {
    padding: 14px 20px;
}

@media (max-width: 1024px) {

    .BC-page_Installation.KYC .Polaris-Card,
    .BC-page_Installation.SuccessInstall .Polaris-Card {
        width: 560px;
    }

    .BC-page_Installation .BC-page_Installation--KYC .wrapper {
        flex-direction: column;
    }

    .BC-page_Installation .BC-page_Installation--KYC .wrapper .content {
        width: 100%;
        background: white;
        border-radius: 10px 10px 0 0;
    }

    .BC-page_Installation .BC-page_Installation--KYC .wrapper .preview {
        width: 100%;
        margin-top: -20px;
    }

    .BC-page_Installation .BC-page_Installation--KYC .wrapper .preview img {
        width: 100%;
        border-radius: 0 0 10px 10px;
    }

    .BC-page_Installation .BC-page_Installation--KYC .wrapper .content .StepForm {
        padding-bottom: 50px;
    }

    .BC-page_Installation .BC-page_Installation--KYC .SelectPlugin {
        justify-content: center;
        grid-template-columns: auto;
    }

    .BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper {
        flex-direction: column;
    }

    .BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content {
        width: 100%;
        background: white;
        border-radius: 10px 10px 0 0;
    }

    .BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .preview {
        width: 100%;
        margin-top: -20px;
    }

    .BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .preview img {
        width: 100%;
        border-radius: 0 0 10px 10px;
    }

    .BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content .StepForm {
        padding-bottom: 50px;
    }
}

/* END: Onboarding */

.BC-page_Installation.ChooseTheme>.Polaris-Card {
    max-width: 1120px;
    width: calc(100% - 20px * 2);
    margin: 20px auto;
}

.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-top {
    display: flex;
    padding: 30px 24px;
    align-items: center;
}

.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-top .info {
    flex: 1;
    width: auto;
}

.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-top .info .title {
    font-weight: 600;
    font-size: 28px;
    line-height: 32px;
    color: #202223;
}

.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-top .info .description {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #202223;
    margin-top: 12px;
}

.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-top .sync-info {
    width: 400px;
    padding-left: 20px;
    display: flex;
    justify-content: flex-end;
}

.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-top .sync-info .card {
    width: 349px;
    height: 108px;
    background: #fafbfb;
    border-radius: 8px;
    padding: 16px 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-top .sync-info .card .est {
    gap: 5px;
    display: flex;
}

.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-top .sync-info .card .percent {
    font-weight: 600;
}

.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-top .sync-info .title {
    display: flex;
    gap: 6px;
    align-items: center;
    font-weight: bold;
}

.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-top .sync-info .title img.loading {
    animation: rotation 2s infinite linear;
}

.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-top .sync-info .progress {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-top .sync-info .progressing {
    width: 250px;
    height: 8px;
    background: #e4e5e7;
    border-radius: 4px;
    display: inline-block;
    overflow: hidden;
}

.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-top .sync-info .progressing::before {
    width: var(--size);
    height: 8px;
    display: block;
    content: '';
    background: #008060;
}

.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-main {
    border-bottom: 1px solid #e1e3e5;
    border-top: 1px solid #e1e3e5;
}

.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-main .Polaris-Card {
    border-radius: 0;
    box-shadow: unset;
    outline: unset;
}

.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-main .Polaris-Card .Polaris-Card__Section {
    padding-bottom: 0;
}

.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .Polaris-ChoiceList {
    padding-bottom: 12px;
}

.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .Polaris-ChoiceList__ChoiceItem {
    margin-top: 8px;
    margin-bottom: 8px;
}

@media (max-width: 40em) {
    .BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .Polaris-ChoiceList__ChoiceChildren {
        margin-top: 0;
    }
}

.BC-page_Installation.ChooseTheme .select-theme>div {
    width: 480px;
}

.BC-page_Installation.ChooseTheme .select-theme {
    width: 520px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.BC-page_Installation.ChooseTheme .select-theme-warning {
    margin-top: 12px;
    color: #916a00;
}

.BC-page_Installation.ChooseTheme .select-theme>div {
    width: 480px;
}

.BC-page_Installation.ChooseTheme .feature-installed-info {
    color: #008060;
    margin-bottom: 10px;
}

.BC-page_Installation.ChooseTheme .title {
    padding-bottom: 0.5625rem;
}

.BC-page_Installation.ChooseTheme .list-features-select>div {
    margin-bottom: 12px;
}

.BC-page_Installation.ChooseTheme .select-recommedation-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 15px;
    margin-top: -15px;
}

.BC-page_Installation.ChooseTheme .BC-Theme-Setup_Form-Item {
    margin-bottom: var(--p-space-5);
}

.BC-page_Installation.ChooseTheme .Polaris-ChoiceList__ChoiceChildren {
    display: inline-block;
    vertical-align: top;
    padding-left: 0.625rem;
}

.BC-page_Installation.ChooseTheme .select-recommedation-wrapper div:nth-child(2) {
    width: 356px;
}

.BC-page_Installation.ChooseTheme .ListRecommendationWidgets {
    border: 1px solid #ccc;
    border-radius: 6px;
    margin-bottom: 10px;
    min-height: 222px;
    padding: 17px;
}

.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .heading {
    font-weight: bold;
}

.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .heading,
.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .content .row {
    display: flex;
    padding: 12px 0;
}

.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .content .data {
    max-height: 400px;
    overflow-y: auto;
}

.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .heading div:nth-child(1),
.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .content .row div:nth-child(1) {
    width: 30px;
    display: flex;
    align-items: flex-start;
}

.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .heading div:nth-child(2),
.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .content .row div:nth-child(2) {
    width: 220px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .heading div:nth-child(3),
.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .content .row div:nth-child(3) {
    flex: 1;
}

.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .heading div:nth-child(4),
.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .content .row div:nth-child(4) {
    width: 230px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .content .row div:nth-child(4) img {
    cursor: pointer;
}

.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .content .data {
    height: 100%;
}

.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .content .empty {
    height: 190px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.BC-page_Installation.ChooseTheme .select-recommedation-widget .add-widget-action {
    text-align: right;
}

.BC-page_Installation.ChooseTheme .select-recommedation-widget .add-widget-action p {
    color: #2c6ecb;
    font-weight: 600;
    cursor: pointer;
}

.select-theme-refresh {
    height: 20px;
}

.BC-page_Installation.ChooseTheme .select-theme-refresh.refreshing {
    animation: rotation 2s infinite linear;
}

.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-bottom {
    display: flex;
    padding: 10px 24px;
    justify-content: space-between;
    align-items: center;
    border-radius: 0 0 0.5rem 0.5rem;
}

.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-bottom .description {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #6d7175;
}

.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-bottom .description i .Polaris-Link {
    text-decoration: none;
    color: #6d7175;
}

.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-bottom .action {}

@media (max-width: 768px) {
    .BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-top {
        flex-direction: column;
    }

    .BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-top .sync-info {
        padding: 20px 0;
        width: 100%;
        padding-bottom: 0;
    }

    .BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-top .sync-info .card {
        width: 100%;
    }

    .BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-top .sync-info .card .progressing {
        width: calc(100% - 45px);
    }

    .BC-page_Installation.ChooseTheme .select-theme {
        width: calc(100% - 20px);
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;
    }

    .BC-page_Installation.ChooseTheme .select-theme>div {
        width: 100%;
    }

    .BC-page_Installation.ChooseTheme .ListRecommendationWidgets {
        overflow-x: auto;
    }

    .BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper {
        min-width: 800px;
    }

    .BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .heading div:nth-child(3),
    .BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .content .row div:nth-child(3) {
        min-width: 200px;
    }
}

.BC-page_Installation.RunningSync>.Polaris-Card {
    max-width: 1120px;
    width: calc(100% - 20px * 2);
    margin: 20px auto;
}

.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .wrapper {
    display: flex;
    align-items: stretch;
}

.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .left {
    width: 520px;
    height: 708px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
}

.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .left .left-img {
    width: 640px;
    height: 640px;
    z-index: 999;
}

.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .left .left-img img {
    width: 100%;
}

.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .left img {
    line-height: 0;
    font-size: 0;
    display: block;
}

.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right {
    width: auto;
    flex: 1;
    display: flex;
    align-items: center;
    position: relative;
}

.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right .contact-us {
    position: absolute;
    bottom: 40px;
    left: 32px;
}

.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right-content {
    width: auto;
    flex: 1;
    padding: 32px;
    min-height: 440px;
}

.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right-content.skeleton {
    display: flex;
    align-items: center;
}

.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right-content .skeleton {
    height: 200px;
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: space-around;
}

.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right-content.has-inner {
    display: flex;
    align-items: center;
}

.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right .title {
    font-size: 28px;
    line-height: 32px;
    color: #202223;
    margin-bottom: 10px;
    font-weight: 600;
    display: flex;
}

.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .dots {
    width: 30px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding-bottom: 4px;
}

.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .dots-3 {
    width: 5px;
    aspect-ratio: 1;
    border-radius: 50%;
    animation: d3 1s infinite linear alternate;
}

@keyframes d3 {
    0% {
        box-shadow: 10px 0 #000, -10px 0 #0002;
        background: #000;
    }

    33% {
        box-shadow: 10px 0 #000, -10px 0 #0002;
        background: #0002;
    }

    66% {
        box-shadow: 10px 0 #0002, -10px 0 #000;
        background: #0002;
    }

    100% {
        box-shadow: 10px 0 #0002, -10px 0 #000;
        background: #000;
    }
}

.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right .description {
    font-size: 14px;
    line-height: 20px;
    color: #202223;
    margin-bottom: 10px;
}

.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right .sync-info {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
}

.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right .sync-info .card {
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
}

.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right .sync-info .title {
    display: flex;
    gap: 6px;
    align-items: center;
    font-size: 16px;
    line-height: 24px;
    color: #202223;
    font-weight: 600;
    margin-bottom: 10px;
}

.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right .sync-info .title span.refresh {
    display: inline-block;
    width: 18px;
}

.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right .sync-info .title img.loading {
    animation: rotation 2s infinite linear;
}

.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right .sync-info .progress {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right .sync-info .progressing {
    height: 8px;
    width: 100%;
    background: #e4e5e7;
    border-radius: 4px;
    display: inline-block;
    overflow: hidden;
}

.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right .sync-info .progressing::before {
    width: var(--size);
    height: 8px;
    display: block;
    content: '';
    background: #008060;
}

.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right .sync-info .est {
    display: flex;
    justify-content: space-between;
}

.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right .sync-info .est-wrap {
    display: flex;
    gap: 5px;
}

.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right .sync-info .est-text {
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #6d7175;
}

.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right .sync-info .est .percent {
    font-weight: 500;
    font-size: 14px;
    color: #202223;
}

.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right .line {
    margin: 35px 0;
    width: 100%;
    height: 1px;
    border-top: 1px solid #e1e3e5;
}

.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right .Polaris-Button {
    margin-top: 15px;
    margin-right: 10px;
}

@media (max-width: 768px) {
    .BC-page_Installation.RunningSync>.Polaris-Card {
        max-width: 520px;
        margin-bottom: 20px;
        border-radius: 8px;
    }

    .BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .wrapper {
        flex-direction: column;
    }

    .BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .wrapper .left,
    .BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .wrapper .left img {
        max-width: 100%;
        border-radius: 8px 8px 0 0;
    }

    .BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .wrapper .left {
        margin-bottom: -10px;
    }

    .BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .wrapper .right {
        background: white;
        border-radius: 0 0 8px 8px;
    }
}

.BC-page_Installation.Survey>.Polaris-Card {
    max-width: 1120px;
    width: calc(100% - 20px * 2);
    margin: 20px auto;
}

.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper {
    display: flex;
    align-items: stretch;
    height: 100%;
    min-height: 180px;
    display: flex;
    flex-direction: column;
    padding: 40px 24px;
    padding-bottom: 20px;
}

.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey--Step2 .wrapper {
    padding-bottom: 0;
}

.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey--Step2 .wrapper .select_feature_list .Polaris-ChoiceList__Title {
    margin-bottom: 10px;
}

body:has(* .BC-page_Installation.Survey) .Polaris-Combobox__Listbox .Polaris-Listbox-Option[aria-selected='true'] .Polaris-Listbox-TextOption {
    background: #f2f7fe;
}

.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .top .title {
    font-weight: 600;
    font-size: 28px;
    line-height: 32px;
    color: #202223;
    margin-bottom: 10px;
}

.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .top .description {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #6d7175;
}

.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .content {
    margin: 20px 0;
}

.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .content .step1 {
    display: flex;
    gap: 30px;
    width: 100%;
}

.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .content .step1 .Polaris-ChoiceList__Choices {
    display: flex;
    gap: 30px;
}

.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .content .step1 .Polaris-ChoiceList__ChoiceItem {
    background: #fafbfb;
    border: 2px solid #fafbfb;
    border-radius: 8px;
    padding: 25px 20px;
    padding-right: 5px;
}

.Polaris-Page-Header {
    padding-top: 2.5rem;
    padding-bottom: 0;
}

.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .content .step1 .Polaris-ChoiceList__ChoiceItem:has(input:checked) {
    border: 2px solid var(--p-interactive);
    background: white;
}

.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .content .step1 .Polaris-ChoiceList__ChoiceItem .Polaris-Choice {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .content .step1 .Polaris-ChoiceList__ChoiceItem .Polaris-Choice__Label {
    font-weight: 600;
    font-size: 20px;
    line-height: 28px;
    color: #202223;
}

.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .content .step1 .Polaris-ChoiceList__ChoiceItem .option {
    padding-left: 27px;
}

.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .content .step1 .Polaris-ChoiceList__ChoiceItem .option .description {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #202223;
    margin-bottom: 20px;
    margin-top: 10px;
}

.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .content .step1 .Polaris-ChoiceList__ChoiceItem .Polaris-ChoiceList__ChoiceChildren {
    padding-left: 0;
}

.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .content .step2 {
    width: 100%;
}

.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .content .step2 .Polaris-ChoiceList__Choices {
    display: flex;
    gap: 30px;
}

.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .content .step2 .multi-select {
    margin-top: 6px;
}

.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .content .step2 .multi-select .Polaris-TextField__VerticalContent {
    padding: 0;
    padding-left: 10px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    overflow: auto;
}

.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .content .step2 .multi-select .Polaris-TextField__Input {
    width: unset;
    display: inline-block;
    width: auto;
    cursor: pointer;
    min-width: 200px;
}

.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .content .step2 .multi-select .Polaris-Tag {
    margin: 5px;
}

.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey--Step2 .action,
.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey--Step3 .action {
    border-top: 1px solid #ccc;
    padding: 10px 24px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey--Step4 .wrapper {
    text-align: center;
}

@media (max-width: 768px) {
    .BC-page_Installation.Survey>.Polaris-Card {
        max-width: 520px;
        margin-bottom: 20px;
        border-radius: 8px;
    }

    .BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .content .step1 .Polaris-ChoiceList__Choices {
        flex-direction: column;
    }
}

.BC-page_Installation.Select-Theme>.Polaris-Card {
    max-width: 1152px;
    width: calc(100% - 20px * 2);
    margin: 20px auto;
}

.BC-page_Installation.Select-Theme .NewUser .title {
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    font-size: 30px;
    margin-bottom: 24px;
    margin-top: 0 !important;
}

.BC-page_Installation.Select-Theme .NewUser .form-select-theme {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.BC-page_Installation.Select-Theme .NewUser .form-select-theme .Polaris-Banner__Ribbon {
    padding-right: 12px;
}

.BC-page_Installation.Select-Theme .NewUser .BC-Shopify-Integration_Select-Theme-Form .desc {
    margin-bottom: 4px;
}

.BC-page_Installation.Select-Theme .NewUser .BC-Shopify-Integration_Select-Theme-Form__Wrapper {
    display: flex;
    align-items: center;
    column-gap: 8px;
    margin-bottom: 2px;
}

.BC-page_Installation.Select-Theme .NewUser .BC-Shopify-Integration_Select-Theme-Form__Wrapper .custom-select {
    flex-grow: 1;
    max-width: 450px;
}


.BC-page_Installation.Select-Theme .NewUser .BC-Shopify-Integration_Select-Theme-Form__Wrapper .checkbox-wrapper {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.BC-page_Installation.Select-Theme .NewUser .BC-Shopify-Integration_Select-Theme-Form__Wrapper .BC-Select-Integration__value-container {
    flex-wrap: nowrap;
}

.BC-page_Installation.Select-Theme .NewUser.select-theme-refresh {
    height: 20px;
    transition: all 0.4s;
    cursor: pointer;
}

.BC-page_Installation.Select-Theme .NewUser .select-theme-refresh.refreshing {
    -webkit-animation: spin 2s linear infinite;
    -moz-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
}

.BC-page_Installation.Select-Theme .NewUser .BC-Shopify-Integration_Select-Theme-Form .btn-wrapper {
    margin-top: 24px;
}

.BC-page_Installation.Select-Theme .NewUser .preview .carousel-root {
    height: 100%;
}

.BC-page_Installation.Select-Theme .NewUser .preview .carousel.carousel-slider {
    height: 100%;
}

.BC-page_Installation.Select-Theme .NewUser .preview .carousel.carousel-slider .slider-wrapper {
    height: 100%;
}

.BC-page_Installation.Select-Theme .NewUser .preview .carousel.carousel-slider .slider-wrapper .slider {
    height: 100%;
}

.BC-page_Installation.Select-Theme .NewUser .preview .carousel.carousel-slider .slider-wrapper .slider .slide {
    height: 100%;
}

.BC-page_Installation.Select-Theme .NewUser .preview .carousel.carousel-slider .slider-wrapper .slider .slide>div {
    height: 100%;
}

.BC-page_Installation.Select-Theme .NewUser .preview .carousel.carousel-slider .control-dots .dot {
    margin: 0 6px;
    width: 6px;
    height: 6px;
    background-color: #C9CCD0;
    opacity: 1;
}

.BC-page_Installation.Select-Theme .NewUser .preview .carousel.carousel-slider .control-dots .dot.selected {
    width: 10px;
    height: 10px;
    background-color: #FF3300;
}

.BC-page_Installation.Select-Theme .NewUser .finish-footer {
    display: flex;
    gap: 8px;
    margin-top: 24px;
}

.BC-page_Installation.Select-Theme img.loading2 {
    animation: rotation 2s infinite linear;
}

@-moz-keyframes spin {
    100% {
        -moz-transform: rotate(360deg);
    }
}

@-webkit-keyframes spin {
    100% {
        -webkit-transform: rotate(360deg);
    }
}

@keyframes spin {
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

@keyframes rotation {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(359deg);
    }
}

/**
 * ==============================================
 * Dot Flashing
 * ==============================================
 */
.BC-page_Installation .dot-flashing {
    position: relative;
    width: 8px;
    height: 8px;
    border-radius: 5px;
    background-color: #202223;
    color: #202223;
    animation: dot-flashing 1s infinite linear alternate;
    animation-delay: 0.5s;
}

.BC-page_Installation .dot-flashing::before,
.dot-flashing::after {
    content: "";
    display: inline-block;
    position: absolute;
    top: 0;
}

.BC-page_Installation .dot-flashing::before {
    left: -14px;
    width: 8px;
    height: 8px;
    border-radius: 5px;
    background-color: #202223;
    color: #202223;
    animation: dot-flashing 1s infinite alternate;
    animation-delay: 0s;
}

.BC-page_Installation .dot-flashing::after {
    left: 14px;
    width: 8px;
    height: 8px;
    border-radius: 5px;
    background-color: #202223;
    color: #202223;
    animation: dot-flashing 1s infinite alternate;
    animation-delay: 1s;
}

@keyframes dot-flashing {
    0% {
        background-color: #202223;
    }

    50%,
    100% {
        background-color: rgba(152, 128, 255, 0.2);
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/installation.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,+CAA+C;IAC/C,kBAAkB;IAClB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;;;IAGI,kCAAkC;AACtC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0CAA0C;IAC1C,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,OAAO;IACP,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,QAAQ;QACR,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;QACjB,4BAA4B;IAChC;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,QAAQ;QACR,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;QACjB,4BAA4B;IAChC;AACJ;;AAEA;;IAEI,gBAAgB;IAChB,mBAAmB;IACnB,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,gBAAgB;IAChB,mBAAmB;IACnB,kCAAkC;IAClC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,sCAAsC;IACtC,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,sCAAsC;IACtC,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,qBAAqB;IACrB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,cAAc;AAClB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,QAAQ;IACR,kBAAkB;IAClB,4BAA4B;IAC5B,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,UAAU;IACV,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,UAAU;AACd;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;;IAEI,iBAAiB;IACjB,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,OAAO;IACP,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,OAAO;IACP,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;IAC5B,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA,2EAA2E;;AAE3E;IACI,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,OAAO;IACP,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;;IAEI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI;;QAEI,YAAY;IAChB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB,4BAA4B;IAChC;;IAEA;QACI,WAAW;QACX,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,4BAA4B;IAChC;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,uBAAuB;QACvB,2BAA2B;IAC/B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB,4BAA4B;IAChC;;IAEA;QACI,WAAW;QACX,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,4BAA4B;IAChC;;IAEA;QACI,oBAAoB;IACxB;AACJ;;AAEA,oBAAoB;;AAEpB;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,QAAQ;IACR,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;;AAEA;;IAEI,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;;IAEI,OAAO;AACX;;AAEA;;IAEI,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,8BAA8B;IAC9B,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA,4GAA4G;;AAE5G;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;QACf,WAAW;QACX,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;QACxB,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;QAEI,gBAAgB;IACpB;AACJ;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,OAAO;IACP,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,WAAW;IACX,OAAO;IACP,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,OAAO;IACP,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI;QACI,sCAAsC;QACtC,gBAAgB;IACpB;;IAEA;QACI,sCAAsC;QACtC,iBAAiB;IACrB;;IAEA;QACI,sCAAsC;QACtC,iBAAiB;IACrB;;IAEA;QACI,sCAAsC;QACtC,gBAAgB;IACpB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI;QACI,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,eAAe;QACf,0BAA0B;IAC9B;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;QACjB,0BAA0B;IAC9B;AACJ;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,sCAAsC;IACtC,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,0BAA0B;IAC1B,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,0CAA0C;IAC1C,uCAAuC;IACvC,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,iCAAiC;QACjC,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;;;;EAIE;AACF;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,oDAAoD;IACpD,qBAAqB;AACzB;;AAEA;;IAEI,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,MAAM;AACV;;AAEA;IACI,WAAW;IACX,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,6CAA6C;IAC7C,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,6CAA6C;IAC7C,mBAAmB;AACvB;;AAEA;IACI;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,0CAA0C;IAC9C;AACJ","sourcesContent":["/* START: Onboarding */\n.BC-page_Installation img {\n    image-rendering: pixelated;\n}\n\n.BC-page_Installation .ButtonCustom .Polaris-Button {\n    padding: 14px 30px;\n    height: 48px;\n    background: #ff3000;\n    box-shadow: 0px 4px 24px rgba(235, 69, 38, 0.4);\n    border-radius: 4px;\n    border: 0;\n    min-width: 110px;\n}\n\n.BC-page_Installation .ButtonCustom .Polaris-Button:hover {\n    background: #e82c00;\n}\n\n.BC-page_Installation .ButtonCustom .Polaris-Button .Polaris-Button__Text {\n    color: white;\n    font-weight: 700;\n    font-size: 14px;\n    letter-spacing: 1px;\n    text-transform: uppercase;\n    font-family: 'Poppins', sans-serif;\n}\n\n.BC-page_Installation .ButtonCustom.disabled .Polaris-Button {\n    box-shadow: none;\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 4px;\n    cursor: not-allowed;\n}\n\n.BC-page_Installation .ButtonCustom.disabled .Polaris-Button .Polaris-Button__Text {\n    color: #8c9196;\n}\n\n.BC-page_Installation.Onboarding *,\n.BC-page_Installation.KYC *,\n.BC-page_Installation.SuccessInstall * {\n    font-family: 'Poppins', sans-serif;\n}\n\n.BC-page_Installation.Onboarding:has(.NewUser) * {\n    font-family: 'SF Pro Text';\n}\n\n.BC-page_Installation.Onboarding .NewUser .title {\n    font-family: 'SF Pro Display', 'Poppins';\n}\n\n.BC-page_Installation.Onboarding .NewUser .description {\n    font-family: 'SF Pro Text';\n}\n\n.BC-page_Installation.Onboarding .Polaris-Card {\n    max-width: 1120px;\n    width: calc(100% - 40px * 2);\n    margin: 0 auto;\n    margin-top: 74px;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper {\n    display: flex;\n    position: relative;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .control-dots {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper {\n    display: flex;\n    flex-direction: row-reverse;\n    border-radius: 10px;\n    max-height: 640px;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .preview,\n.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .preview img {\n    border-radius: 0 10px 10px 0;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .btn-pre,\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .btn-next {\n    position: absolute;\n    width: 44px;\n    height: 44px;\n    border-radius: 50%;\n    background: white;\n    top: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);\n    cursor: pointer;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .btn-pre {\n    transform: translateY(-50%);\n    left: -22px;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .btn-next {\n    transform: translateY(-50%);\n    right: -22px;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .preview {\n    width: 576px;\n    flex-shrink: 0;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .preview img {\n    max-width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content {\n    flex: 1;\n    width: auto;\n    min-height: 640px;\n    padding: 26px 29px;\n    position: relative;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content.form-onboarding-plan {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content {\n    padding: 26px 40px;\n}\n\n@media (max-width: 1024px) {\n    .BC-page_Installation.Onboarding .Polaris-Card {\n        width: 560px;\n    }\n\n    .BC-page_Installation .BC-page_Installation--Onboarding .wrapper {\n        flex-direction: column;\n    }\n\n    .BC-page_Installation .BC-page_Installation--Onboarding .wrapper .btn-pre,\n    .BC-page_Installation .BC-page_Installation--Onboarding .wrapper .btn-next {\n        top: 75%;\n        z-index: 10;\n    }\n\n    .BC-page_Installation .BC-page_Installation--Onboarding .wrapper .preview {\n        width: 100%;\n    }\n\n    .BC-page_Installation .BC-page_Installation--Onboarding .wrapper .preview img {\n        border-radius: 10px 10px 0 0;\n    }\n\n    .BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content {\n        margin-top: -20px;\n        background: white;\n        border-radius: 0 0 10px 10px;\n    }\n\n    .BC-page_Installation.Onboarding.NewUser .Polaris-Card {\n        width: 560px;\n    }\n\n    .BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper {\n        flex-direction: column;\n    }\n\n    .BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .btn-pre,\n    .BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .btn-next {\n        top: 75%;\n        z-index: 10;\n    }\n\n    .BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .preview {\n        width: 100%;\n    }\n\n    .BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .preview img {\n        border-radius: 10px 10px 0 0;\n    }\n\n    .BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content {\n        margin-top: -20px;\n        background: white;\n        border-radius: 0 0 10px 10px;\n    }\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content.form-email-opt .title,\n.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content.form-onboarding-plan .title {\n    text-align: left;\n    margin-bottom: 48px;\n    font-family: 'SF Pro Display', sans-serif;\n    font-size: 42px;\n    font-weight: 700;\n    line-height: 44px;\n    margin-top: 95px;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content.form-onboarding-plan .title {\n    margin-top: 0;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content.form-email-opt .subtitle,\n.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content.form-onboarding-plan .subtitle {\n    text-align: left;\n    margin-bottom: 24px;\n    font-family: 'Poppins', sans-serif;\n    font-size: 30px;\n    font-weight: 600;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content.form-email-opt .desc {\n    text-align: left;\n    margin-bottom: 32px;\n    font-family: 'SF Pro Text', sans-serif;\n    line-height: 20px;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content.form-onboarding-plan .desc {\n    text-align: left;\n    margin-bottom: 24px;\n    font-family: 'SF Pro Text', sans-serif;\n    line-height: 20px;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content.form-email-opt .Polaris-Label .Polaris-Label__Text {\n    margin-bottom: 5px;\n    font-weight: 400 !important;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content.form-email-opt .Polaris-FormLayout {\n    margin-bottom: 25px;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content.form-email-opt .Polaris-FormLayout input {\n    min-height: 2.375rem;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content.form-email-opt .Polaris-InlineError .Polaris-InlineError__Icon {\n    display: block;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content.form-email-opt .menu {\n    position: static;\n    display: block;\n    margin-top: 25px;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content.form-onboarding-plan .menu {\n    position: static;\n    display: block;\n    margin: 0;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .skip {\n    text-align: right;\n    font-weight: 400;\n    font-size: 14px;\n    color: #6d7175;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .skip span {\n    cursor: pointer;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .badge {\n    max-width: fit-content;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 16px;\n    letter-spacing: 0px;\n    text-align: center;\n    border: 1px solid #eaecf0;\n    border-radius: 16px;\n    color: #344054;\n    background: #f9fafb;\n    padding: 2px 8px;\n    margin-bottom: 10px;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .title {\n    font-weight: 600;\n    font-size: 28px;\n    line-height: 32px;\n    color: #202223;\n    margin-top: 120px;\n    display: flex;\n    align-items: baseline;\n    gap: 18px;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .description {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    text-align: center;\n    color: #202223;\n    margin-top: 24px;\n    padding: 0 10px;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .description.step-5 {\n    font-size: 30px;\n    line-height: 40px;\n    margin-top: 0px;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .step {\n    margin-top: 150px;\n    position: absolute;\n    bottom: 200px;\n    position: absolute;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .Step,\n.render-choice-2 .Polaris-ChoiceList__Choices li {\n    display: flex;\n    align-items: center;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .Step {\n    justify-content: center;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .Step .item {\n    width: 6px;\n    height: 6px;\n    background: #c9ccd0;\n    margin: 3px;\n    border-radius: 50%;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .Step .active {\n    width: 10px;\n    height: 10px;\n    background: #ff3300;\n    border-radius: 50%;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .menu {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    margin-top: 50px;\n    bottom: 100px;\n    position: absolute;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .menu .back {\n    display: flex;\n    position: absolute;\n    left: 45px;\n    align-items: center;\n    cursor: pointer;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .menu .back .Polaris-Icon {\n    width: 12px;\n    height: unset;\n    margin: 10px;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .menu .back .Polaris-Icon svg {\n    fill: black;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .onboarding-features .feature-item {\n    gap: 8px;\n    border-radius: 8px;\n    padding: 16px 24px 16px 16px;\n    margin-bottom: 12px;\n    background: #fafbfb;\n    border: 1px solid #fafbfb;\n    cursor: pointer;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .onboarding-features .feature-item.selected {\n    border: 1px solid #008060;\n    background: #f1f8f5;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .onboarding-features .feature-item.selected .Polaris-Checkbox__Backdrop::before {\n    background: #008060;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .onboarding-features .feature-item .label {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0;\n    min-height: auto;\n    margin-bottom: 8px;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .onboarding-features .feature-item .desc {\n    color: #6d7175;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .onboarding-features img {\n    display: none;\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 1;\n}\n\n.BC-page_Installation.KYC,\n.BC-page_Installation.SuccessInstall {\n    padding-bottom: 30px;\n}\n\n.BC-page_Installation.KYC .Polaris-Card,\n.BC-page_Installation.SuccessInstall .Polaris-Card {\n    max-width: 1160px;\n    width: calc(100% - 20px * 2);\n    margin: 20px auto;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .wrapper {\n    display: flex;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .wrapper .content {\n    flex: 1;\n    padding: 40px 56px;\n    position: relative;\n    min-height: 600px;\n    display: flex;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .StepForm {\n    height: auto;\n    position: relative;\n    width: 100%;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .StepForm .title {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 30px;\n    color: #202223;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .StepForm .description {\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    color: #6d7175;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .StepForm .step {\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #8c9196;\n    margin-top: 40px;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .StepForm .step-title {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 30px;\n    line-height: 40px;\n    color: #202223;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .StepForm .step-description {\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #6d7175;\n    margin-top: 8px;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .StepForm .step-form {\n    margin-top: 40px;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .menu {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    position: relative;\n    margin-top: 50px;\n    bottom: 0;\n    position: absolute;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .menu .back {\n    display: flex;\n    position: absolute;\n    left: 0;\n    align-items: center;\n    cursor: pointer;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .menu .back .Polaris-Icon {\n    width: 12px;\n    height: unset;\n    margin: 10px;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .menu .back .Polaris-Icon svg {\n    fill: black;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .wrapper .preview {\n    width: 440px;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .wrapper .preview img {\n    width: 440px;\n    height: 100%;\n    font-size: 0;\n    line-height: 0;\n    display: block;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin {\n    display: grid;\n    grid-template-columns: auto auto;\n    grid-gap: 16px;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item {\n    min-height: 166px;\n    width: 296px;\n    position: relative;\n    padding: 20px 12px 20px 20px;\n    border: 2px solid #fafbfb;\n    border-radius: 8px;\n    background: #fafbfb;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item:hover {\n    background: #fff8f6;\n    cursor: pointer;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item:hover~.BC-page_Installation .BC-page_Installation--KYC .wrapper .preview {\n    border: 4px solid red;\n    border-color: var(--hover);\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item .Polaris-Choice {\n    position: absolute;\n    right: 12px;\n    top: 12px;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item .Polaris-Choice .Polaris-Checkbox__Backdrop {\n    border: 1px solid #c9cccf;\n    border-radius: 4px;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item .Polaris-Choice .Polaris-Checkbox__Backdrop::before {\n    background-color: #ff3000;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item .Polaris-Choice .Polaris-Choice__Control {\n    margin-right: 0;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item .icon {\n    width: 24px;\n    height: 24px;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item .title {\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 24px;\n    color: #202223;\n    margin-top: 8px;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item .description {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #6d7175;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item--Selected,\n.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item--Selected:hover {\n    border: 2px solid #ff8366;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .SelectKind {\n    margin-bottom: 20px;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .SelectKind .Polaris-TextField__Input {\n    min-height: 56px;\n    border: px solid #a1a3ad;\n    border-radius: 8px;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .SelectKind .Polaris-TextField {\n    --p-focused: white;\n    /* --p-focused: #FF3000; */\n    border-radius: 10px;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .SelectKind .Polaris-TextField--focus .Polaris-TextField__Input {\n    border: 2px solid #ff3000;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .SelectKind .Polaris-TextField__Backdrop {\n    border-radius: 8px;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .SelectIndustriesWrapper {}\n\n.BC-page_Installation .BC-page_Installation--KYC .IndustryList {\n    padding: 2px;\n    display: flex;\n    flex-wrap: wrap;\n    column-gap: 10px;\n    row-gap: 10px;\n    gap: 10px;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .IndustryItem {\n    padding: 6px 8px;\n    background: #f1f2f3;\n    border-radius: 4px;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .IndustryItem:not(.IndustryItem__Selected) {\n    cursor: pointer;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .IndustryItem__Selected {\n    background: #ffefeb;\n    color: #ff3000;\n}\n\n.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper {\n    display: flex;\n}\n\n.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content {\n    flex: 1;\n    min-height: 600px;\n    position: relative;\n}\n\n.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content .inner-content {\n    max-width: 540px;\n    color: #202223;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: calc(100% - 80px);\n    transform: translate(-50%, -50%);\n}\n\n.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content .inner-content .title {\n    font-weight: 600;\n    font-size: 30px;\n    line-height: 40px;\n    margin-bottom: 35px;\n}\n\n.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content .inner-content .description,\n.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content .inner-content .list {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    margin-bottom: 20px;\n}\n\n.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content .inner-content .description {\n    margin-bottom: 16px;\n}\n\n.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content .inner-content .list .item {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 10px;\n}\n\n.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content .inner-content .list img {\n    margin-top: 4px;\n}\n\n.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content .inner-content .list .title2 {\n    font-weight: 600;\n}\n\n.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content .inner-content .action {\n    display: flex;\n    gap: 10px;\n}\n\n.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content .inner-content .action>.Polaris-Button {\n    border: 1px solid #292929;\n    box-shadow: 0px 4px 24px 0px #eb452633;\n}\n\n.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content .inner-content .action>.Polaris-Button .Polaris-Button__Text {\n    text-transform: uppercase;\n    color: #292929;\n    font-weight: 700;\n    font-size: 14px;\n}\n\n.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .preview {\n    width: 540px;\n}\n\n.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .preview img {\n    width: 540px;\n    height: 100%;\n    font-size: 0;\n    line-height: 0;\n    display: block;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .IndustryList {\n    margin-top: 20px;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .step4 {\n    height: 100%;\n    display: flex;\n    align-items: center;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .step4-content .ButtonCustom {\n    margin-top: 30px;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .step4-content .ButtonCustom .Polaris-Button {\n    padding: 14px 20px;\n}\n\n@media (max-width: 1024px) {\n\n    .BC-page_Installation.KYC .Polaris-Card,\n    .BC-page_Installation.SuccessInstall .Polaris-Card {\n        width: 560px;\n    }\n\n    .BC-page_Installation .BC-page_Installation--KYC .wrapper {\n        flex-direction: column;\n    }\n\n    .BC-page_Installation .BC-page_Installation--KYC .wrapper .content {\n        width: 100%;\n        background: white;\n        border-radius: 10px 10px 0 0;\n    }\n\n    .BC-page_Installation .BC-page_Installation--KYC .wrapper .preview {\n        width: 100%;\n        margin-top: -20px;\n    }\n\n    .BC-page_Installation .BC-page_Installation--KYC .wrapper .preview img {\n        width: 100%;\n        border-radius: 0 0 10px 10px;\n    }\n\n    .BC-page_Installation .BC-page_Installation--KYC .wrapper .content .StepForm {\n        padding-bottom: 50px;\n    }\n\n    .BC-page_Installation .BC-page_Installation--KYC .SelectPlugin {\n        justify-content: center;\n        grid-template-columns: auto;\n    }\n\n    .BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper {\n        flex-direction: column;\n    }\n\n    .BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content {\n        width: 100%;\n        background: white;\n        border-radius: 10px 10px 0 0;\n    }\n\n    .BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .preview {\n        width: 100%;\n        margin-top: -20px;\n    }\n\n    .BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .preview img {\n        width: 100%;\n        border-radius: 0 0 10px 10px;\n    }\n\n    .BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content .StepForm {\n        padding-bottom: 50px;\n    }\n}\n\n/* END: Onboarding */\n\n.BC-page_Installation.ChooseTheme>.Polaris-Card {\n    max-width: 1120px;\n    width: calc(100% - 20px * 2);\n    margin: 20px auto;\n}\n\n.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-top {\n    display: flex;\n    padding: 30px 24px;\n    align-items: center;\n}\n\n.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-top .info {\n    flex: 1;\n    width: auto;\n}\n\n.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-top .info .title {\n    font-weight: 600;\n    font-size: 28px;\n    line-height: 32px;\n    color: #202223;\n}\n\n.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-top .info .description {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #202223;\n    margin-top: 12px;\n}\n\n.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-top .sync-info {\n    width: 400px;\n    padding-left: 20px;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-top .sync-info .card {\n    width: 349px;\n    height: 108px;\n    background: #fafbfb;\n    border-radius: 8px;\n    padding: 16px 24px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-top .sync-info .card .est {\n    gap: 5px;\n    display: flex;\n}\n\n.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-top .sync-info .card .percent {\n    font-weight: 600;\n}\n\n.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-top .sync-info .title {\n    display: flex;\n    gap: 6px;\n    align-items: center;\n    font-weight: bold;\n}\n\n.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-top .sync-info .title img.loading {\n    animation: rotation 2s infinite linear;\n}\n\n.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-top .sync-info .progress {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-top .sync-info .progressing {\n    width: 250px;\n    height: 8px;\n    background: #e4e5e7;\n    border-radius: 4px;\n    display: inline-block;\n    overflow: hidden;\n}\n\n.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-top .sync-info .progressing::before {\n    width: var(--size);\n    height: 8px;\n    display: block;\n    content: '';\n    background: #008060;\n}\n\n.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-main {\n    border-bottom: 1px solid #e1e3e5;\n    border-top: 1px solid #e1e3e5;\n}\n\n.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-main .Polaris-Card {\n    border-radius: 0;\n    box-shadow: unset;\n    outline: unset;\n}\n\n.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-main .Polaris-Card .Polaris-Card__Section {\n    padding-bottom: 0;\n}\n\n.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .Polaris-ChoiceList {\n    padding-bottom: 12px;\n}\n\n.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .Polaris-ChoiceList__ChoiceItem {\n    margin-top: 8px;\n    margin-bottom: 8px;\n}\n\n@media (max-width: 40em) {\n    .BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .Polaris-ChoiceList__ChoiceChildren {\n        margin-top: 0;\n    }\n}\n\n.BC-page_Installation.ChooseTheme .select-theme>div {\n    width: 480px;\n}\n\n.BC-page_Installation.ChooseTheme .select-theme {\n    width: 520px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.BC-page_Installation.ChooseTheme .select-theme-warning {\n    margin-top: 12px;\n    color: #916a00;\n}\n\n.BC-page_Installation.ChooseTheme .select-theme>div {\n    width: 480px;\n}\n\n.BC-page_Installation.ChooseTheme .feature-installed-info {\n    color: #008060;\n    margin-bottom: 10px;\n}\n\n.BC-page_Installation.ChooseTheme .title {\n    padding-bottom: 0.5625rem;\n}\n\n.BC-page_Installation.ChooseTheme .list-features-select>div {\n    margin-bottom: 12px;\n}\n\n.BC-page_Installation.ChooseTheme .select-recommedation-wrapper {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    margin-bottom: 15px;\n    margin-top: -15px;\n}\n\n.BC-page_Installation.ChooseTheme .BC-Theme-Setup_Form-Item {\n    margin-bottom: var(--p-space-5);\n}\n\n.BC-page_Installation.ChooseTheme .Polaris-ChoiceList__ChoiceChildren {\n    display: inline-block;\n    vertical-align: top;\n    padding-left: 0.625rem;\n}\n\n.BC-page_Installation.ChooseTheme .select-recommedation-wrapper div:nth-child(2) {\n    width: 356px;\n}\n\n.BC-page_Installation.ChooseTheme .ListRecommendationWidgets {\n    border: 1px solid #ccc;\n    border-radius: 6px;\n    margin-bottom: 10px;\n    min-height: 222px;\n    padding: 17px;\n}\n\n.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .heading {\n    font-weight: bold;\n}\n\n.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .heading,\n.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .content .row {\n    display: flex;\n    padding: 12px 0;\n}\n\n.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .content .data {\n    max-height: 400px;\n    overflow-y: auto;\n}\n\n.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .heading div:nth-child(1),\n.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .content .row div:nth-child(1) {\n    width: 30px;\n    display: flex;\n    align-items: flex-start;\n}\n\n.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .heading div:nth-child(2),\n.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .content .row div:nth-child(2) {\n    width: 220px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .heading div:nth-child(3),\n.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .content .row div:nth-child(3) {\n    flex: 1;\n}\n\n.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .heading div:nth-child(4),\n.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .content .row div:nth-child(4) {\n    width: 230px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .content .row div:nth-child(4) img {\n    cursor: pointer;\n}\n\n.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .content .data {\n    height: 100%;\n}\n\n.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .content .empty {\n    height: 190px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n}\n\n.BC-page_Installation.ChooseTheme .select-recommedation-widget .add-widget-action {\n    text-align: right;\n}\n\n.BC-page_Installation.ChooseTheme .select-recommedation-widget .add-widget-action p {\n    color: #2c6ecb;\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.select-theme-refresh {\n    height: 20px;\n}\n\n.BC-page_Installation.ChooseTheme .select-theme-refresh.refreshing {\n    animation: rotation 2s infinite linear;\n}\n\n.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-bottom {\n    display: flex;\n    padding: 10px 24px;\n    justify-content: space-between;\n    align-items: center;\n    border-radius: 0 0 0.5rem 0.5rem;\n}\n\n.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-bottom .description {\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    color: #6d7175;\n}\n\n.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-bottom .description i .Polaris-Link {\n    text-decoration: none;\n    color: #6d7175;\n}\n\n.BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-bottom .action {}\n\n@media (max-width: 768px) {\n    .BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-top {\n        flex-direction: column;\n    }\n\n    .BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-top .sync-info {\n        padding: 20px 0;\n        width: 100%;\n        padding-bottom: 0;\n    }\n\n    .BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-top .sync-info .card {\n        width: 100%;\n    }\n\n    .BC-page_Installation.ChooseTheme>.Polaris-Card .BC-page_Installation--ChooseTheme .content-top .sync-info .card .progressing {\n        width: calc(100% - 45px);\n    }\n\n    .BC-page_Installation.ChooseTheme .select-theme {\n        width: calc(100% - 20px);\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        gap: 10px;\n    }\n\n    .BC-page_Installation.ChooseTheme .select-theme>div {\n        width: 100%;\n    }\n\n    .BC-page_Installation.ChooseTheme .ListRecommendationWidgets {\n        overflow-x: auto;\n    }\n\n    .BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper {\n        min-width: 800px;\n    }\n\n    .BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .heading div:nth-child(3),\n    .BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .content .row div:nth-child(3) {\n        min-width: 200px;\n    }\n}\n\n.BC-page_Installation.RunningSync>.Polaris-Card {\n    max-width: 1120px;\n    width: calc(100% - 20px * 2);\n    margin: 20px auto;\n}\n\n.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .wrapper {\n    display: flex;\n    align-items: stretch;\n}\n\n.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .left {\n    width: 520px;\n    height: 708px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n}\n\n.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .left .left-img {\n    width: 640px;\n    height: 640px;\n    z-index: 999;\n}\n\n.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .left .left-img img {\n    width: 100%;\n}\n\n.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .left img {\n    line-height: 0;\n    font-size: 0;\n    display: block;\n}\n\n.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right {\n    width: auto;\n    flex: 1;\n    display: flex;\n    align-items: center;\n    position: relative;\n}\n\n.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right .contact-us {\n    position: absolute;\n    bottom: 40px;\n    left: 32px;\n}\n\n.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right-content {\n    width: auto;\n    flex: 1;\n    padding: 32px;\n    min-height: 440px;\n}\n\n.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right-content.skeleton {\n    display: flex;\n    align-items: center;\n}\n\n.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right-content .skeleton {\n    height: 200px;\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    justify-content: space-around;\n}\n\n.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right-content.has-inner {\n    display: flex;\n    align-items: center;\n}\n\n.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right .title {\n    font-size: 28px;\n    line-height: 32px;\n    color: #202223;\n    margin-bottom: 10px;\n    font-weight: 600;\n    display: flex;\n}\n\n.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .dots {\n    width: 30px;\n    display: flex;\n    align-items: flex-end;\n    justify-content: center;\n    padding-bottom: 4px;\n}\n\n.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .dots-3 {\n    width: 5px;\n    aspect-ratio: 1;\n    border-radius: 50%;\n    animation: d3 1s infinite linear alternate;\n}\n\n@keyframes d3 {\n    0% {\n        box-shadow: 10px 0 #000, -10px 0 #0002;\n        background: #000;\n    }\n\n    33% {\n        box-shadow: 10px 0 #000, -10px 0 #0002;\n        background: #0002;\n    }\n\n    66% {\n        box-shadow: 10px 0 #0002, -10px 0 #000;\n        background: #0002;\n    }\n\n    100% {\n        box-shadow: 10px 0 #0002, -10px 0 #000;\n        background: #000;\n    }\n}\n\n.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right .description {\n    font-size: 14px;\n    line-height: 20px;\n    color: #202223;\n    margin-bottom: 10px;\n}\n\n.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right .sync-info {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 20px;\n}\n\n.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right .sync-info .card {\n    border-radius: 8px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right .sync-info .title {\n    display: flex;\n    gap: 6px;\n    align-items: center;\n    font-size: 16px;\n    line-height: 24px;\n    color: #202223;\n    font-weight: 600;\n    margin-bottom: 10px;\n}\n\n.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right .sync-info .title span.refresh {\n    display: inline-block;\n    width: 18px;\n}\n\n.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right .sync-info .title img.loading {\n    animation: rotation 2s infinite linear;\n}\n\n.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right .sync-info .progress {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 10px;\n}\n\n.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right .sync-info .progressing {\n    height: 8px;\n    width: 100%;\n    background: #e4e5e7;\n    border-radius: 4px;\n    display: inline-block;\n    overflow: hidden;\n}\n\n.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right .sync-info .progressing::before {\n    width: var(--size);\n    height: 8px;\n    display: block;\n    content: '';\n    background: #008060;\n}\n\n.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right .sync-info .est {\n    display: flex;\n    justify-content: space-between;\n}\n\n.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right .sync-info .est-wrap {\n    display: flex;\n    gap: 5px;\n}\n\n.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right .sync-info .est-text {\n    font-size: 14px;\n    line-height: 20px;\n    display: flex;\n    align-items: center;\n    color: #6d7175;\n}\n\n.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right .sync-info .est .percent {\n    font-weight: 500;\n    font-size: 14px;\n    color: #202223;\n}\n\n.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right .line {\n    margin: 35px 0;\n    width: 100%;\n    height: 1px;\n    border-top: 1px solid #e1e3e5;\n}\n\n.BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .right .Polaris-Button {\n    margin-top: 15px;\n    margin-right: 10px;\n}\n\n@media (max-width: 768px) {\n    .BC-page_Installation.RunningSync>.Polaris-Card {\n        max-width: 520px;\n        margin-bottom: 20px;\n        border-radius: 8px;\n    }\n\n    .BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .wrapper {\n        flex-direction: column;\n    }\n\n    .BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .wrapper .left,\n    .BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .wrapper .left img {\n        max-width: 100%;\n        border-radius: 8px 8px 0 0;\n    }\n\n    .BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .wrapper .left {\n        margin-bottom: -10px;\n    }\n\n    .BC-page_Installation.RunningSync>.Polaris-Card .BC-page_Installation--RunningSync .wrapper .right {\n        background: white;\n        border-radius: 0 0 8px 8px;\n    }\n}\n\n.BC-page_Installation.Survey>.Polaris-Card {\n    max-width: 1120px;\n    width: calc(100% - 20px * 2);\n    margin: 20px auto;\n}\n\n.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper {\n    display: flex;\n    align-items: stretch;\n    height: 100%;\n    min-height: 180px;\n    display: flex;\n    flex-direction: column;\n    padding: 40px 24px;\n    padding-bottom: 20px;\n}\n\n.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey--Step2 .wrapper {\n    padding-bottom: 0;\n}\n\n.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey--Step2 .wrapper .select_feature_list .Polaris-ChoiceList__Title {\n    margin-bottom: 10px;\n}\n\nbody:has(* .BC-page_Installation.Survey) .Polaris-Combobox__Listbox .Polaris-Listbox-Option[aria-selected='true'] .Polaris-Listbox-TextOption {\n    background: #f2f7fe;\n}\n\n.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .top .title {\n    font-weight: 600;\n    font-size: 28px;\n    line-height: 32px;\n    color: #202223;\n    margin-bottom: 10px;\n}\n\n.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .top .description {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #6d7175;\n}\n\n.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .content {\n    margin: 20px 0;\n}\n\n.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .content .step1 {\n    display: flex;\n    gap: 30px;\n    width: 100%;\n}\n\n.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .content .step1 .Polaris-ChoiceList__Choices {\n    display: flex;\n    gap: 30px;\n}\n\n.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .content .step1 .Polaris-ChoiceList__ChoiceItem {\n    background: #fafbfb;\n    border: 2px solid #fafbfb;\n    border-radius: 8px;\n    padding: 25px 20px;\n    padding-right: 5px;\n}\n\n.Polaris-Page-Header {\n    padding-top: 2.5rem;\n    padding-bottom: 0;\n}\n\n.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .content .step1 .Polaris-ChoiceList__ChoiceItem:has(input:checked) {\n    border: 2px solid var(--p-interactive);\n    background: white;\n}\n\n.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .content .step1 .Polaris-ChoiceList__ChoiceItem .Polaris-Choice {\n    display: flex;\n    align-items: center;\n    margin-bottom: 10px;\n}\n\n.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .content .step1 .Polaris-ChoiceList__ChoiceItem .Polaris-Choice__Label {\n    font-weight: 600;\n    font-size: 20px;\n    line-height: 28px;\n    color: #202223;\n}\n\n.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .content .step1 .Polaris-ChoiceList__ChoiceItem .option {\n    padding-left: 27px;\n}\n\n.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .content .step1 .Polaris-ChoiceList__ChoiceItem .option .description {\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    color: #202223;\n    margin-bottom: 20px;\n    margin-top: 10px;\n}\n\n.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .content .step1 .Polaris-ChoiceList__ChoiceItem .Polaris-ChoiceList__ChoiceChildren {\n    padding-left: 0;\n}\n\n.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .content .step2 {\n    width: 100%;\n}\n\n.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .content .step2 .Polaris-ChoiceList__Choices {\n    display: flex;\n    gap: 30px;\n}\n\n.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .content .step2 .multi-select {\n    margin-top: 6px;\n}\n\n.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .content .step2 .multi-select .Polaris-TextField__VerticalContent {\n    padding: 0;\n    padding-left: 10px;\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    overflow: auto;\n}\n\n.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .content .step2 .multi-select .Polaris-TextField__Input {\n    width: unset;\n    display: inline-block;\n    width: auto;\n    cursor: pointer;\n    min-width: 200px;\n}\n\n.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .content .step2 .multi-select .Polaris-Tag {\n    margin: 5px;\n}\n\n.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey--Step2 .action,\n.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey--Step3 .action {\n    border-top: 1px solid #ccc;\n    padding: 10px 24px;\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n}\n\n.BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey--Step4 .wrapper {\n    text-align: center;\n}\n\n@media (max-width: 768px) {\n    .BC-page_Installation.Survey>.Polaris-Card {\n        max-width: 520px;\n        margin-bottom: 20px;\n        border-radius: 8px;\n    }\n\n    .BC-page_Installation.Survey>.Polaris-Card .BC-page_Installation--Survey .wrapper .content .step1 .Polaris-ChoiceList__Choices {\n        flex-direction: column;\n    }\n}\n\n.BC-page_Installation.Select-Theme>.Polaris-Card {\n    max-width: 1152px;\n    width: calc(100% - 20px * 2);\n    margin: 20px auto;\n}\n\n.BC-page_Installation.Select-Theme .NewUser .title {\n    font-family: 'Poppins', sans-serif;\n    font-weight: 600;\n    font-size: 30px;\n    margin-bottom: 24px;\n    margin-top: 0 !important;\n}\n\n.BC-page_Installation.Select-Theme .NewUser .form-select-theme {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.BC-page_Installation.Select-Theme .NewUser .form-select-theme .Polaris-Banner__Ribbon {\n    padding-right: 12px;\n}\n\n.BC-page_Installation.Select-Theme .NewUser .BC-Shopify-Integration_Select-Theme-Form .desc {\n    margin-bottom: 4px;\n}\n\n.BC-page_Installation.Select-Theme .NewUser .BC-Shopify-Integration_Select-Theme-Form__Wrapper {\n    display: flex;\n    align-items: center;\n    column-gap: 8px;\n    margin-bottom: 2px;\n}\n\n.BC-page_Installation.Select-Theme .NewUser .BC-Shopify-Integration_Select-Theme-Form__Wrapper .custom-select {\n    flex-grow: 1;\n    max-width: 450px;\n}\n\n\n.BC-page_Installation.Select-Theme .NewUser .BC-Shopify-Integration_Select-Theme-Form__Wrapper .checkbox-wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.BC-page_Installation.Select-Theme .NewUser .BC-Shopify-Integration_Select-Theme-Form__Wrapper .BC-Select-Integration__value-container {\n    flex-wrap: nowrap;\n}\n\n.BC-page_Installation.Select-Theme .NewUser.select-theme-refresh {\n    height: 20px;\n    transition: all 0.4s;\n    cursor: pointer;\n}\n\n.BC-page_Installation.Select-Theme .NewUser .select-theme-refresh.refreshing {\n    -webkit-animation: spin 2s linear infinite;\n    -moz-animation: spin 2s linear infinite;\n    animation: spin 2s linear infinite;\n}\n\n.BC-page_Installation.Select-Theme .NewUser .BC-Shopify-Integration_Select-Theme-Form .btn-wrapper {\n    margin-top: 24px;\n}\n\n.BC-page_Installation.Select-Theme .NewUser .preview .carousel-root {\n    height: 100%;\n}\n\n.BC-page_Installation.Select-Theme .NewUser .preview .carousel.carousel-slider {\n    height: 100%;\n}\n\n.BC-page_Installation.Select-Theme .NewUser .preview .carousel.carousel-slider .slider-wrapper {\n    height: 100%;\n}\n\n.BC-page_Installation.Select-Theme .NewUser .preview .carousel.carousel-slider .slider-wrapper .slider {\n    height: 100%;\n}\n\n.BC-page_Installation.Select-Theme .NewUser .preview .carousel.carousel-slider .slider-wrapper .slider .slide {\n    height: 100%;\n}\n\n.BC-page_Installation.Select-Theme .NewUser .preview .carousel.carousel-slider .slider-wrapper .slider .slide>div {\n    height: 100%;\n}\n\n.BC-page_Installation.Select-Theme .NewUser .preview .carousel.carousel-slider .control-dots .dot {\n    margin: 0 6px;\n    width: 6px;\n    height: 6px;\n    background-color: #C9CCD0;\n    opacity: 1;\n}\n\n.BC-page_Installation.Select-Theme .NewUser .preview .carousel.carousel-slider .control-dots .dot.selected {\n    width: 10px;\n    height: 10px;\n    background-color: #FF3300;\n}\n\n.BC-page_Installation.Select-Theme .NewUser .finish-footer {\n    display: flex;\n    gap: 8px;\n    margin-top: 24px;\n}\n\n.BC-page_Installation.Select-Theme img.loading2 {\n    animation: rotation 2s infinite linear;\n}\n\n@-moz-keyframes spin {\n    100% {\n        -moz-transform: rotate(360deg);\n    }\n}\n\n@-webkit-keyframes spin {\n    100% {\n        -webkit-transform: rotate(360deg);\n    }\n}\n\n@keyframes spin {\n    100% {\n        -webkit-transform: rotate(360deg);\n        transform: rotate(360deg);\n    }\n}\n\n@keyframes rotation {\n    from {\n        transform: rotate(0deg);\n    }\n\n    to {\n        transform: rotate(359deg);\n    }\n}\n\n/**\n * ==============================================\n * Dot Flashing\n * ==============================================\n */\n.BC-page_Installation .dot-flashing {\n    position: relative;\n    width: 8px;\n    height: 8px;\n    border-radius: 5px;\n    background-color: #202223;\n    color: #202223;\n    animation: dot-flashing 1s infinite linear alternate;\n    animation-delay: 0.5s;\n}\n\n.BC-page_Installation .dot-flashing::before,\n.dot-flashing::after {\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    top: 0;\n}\n\n.BC-page_Installation .dot-flashing::before {\n    left: -14px;\n    width: 8px;\n    height: 8px;\n    border-radius: 5px;\n    background-color: #202223;\n    color: #202223;\n    animation: dot-flashing 1s infinite alternate;\n    animation-delay: 0s;\n}\n\n.BC-page_Installation .dot-flashing::after {\n    left: 14px;\n    width: 8px;\n    height: 8px;\n    border-radius: 5px;\n    background-color: #202223;\n    color: #202223;\n    animation: dot-flashing 1s infinite alternate;\n    animation-delay: 1s;\n}\n\n@keyframes dot-flashing {\n    0% {\n        background-color: #202223;\n    }\n\n    50%,\n    100% {\n        background-color: rgba(152, 128, 255, 0.2);\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
